const requireComponent = require.context('.', false, /Module\.js$/);

//todo refactor this magic away, use simple object destructoring & named imports

//todo resulting object structure will be:
// {
// config: configModule,
// auth: authModule,
// ...
// }

export default requireComponent.keys().reduce((result, name) => {
    let module = requireComponent(name);
    name = name.replace(/^\.\/(.*)Module\.\w+$/, '$1');
    result[name] =  module.default;
    return result;
}, {});